module.exports = __webpack_public_path__ + "static/polityka_prywatnosci-27f310dacae30fbfc4029fe26db49d3a.pdf";